/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Status of performed subscription operation
 */
export enum SubscriptionStatus {
  SUCCESS = 'SUCCESS',
  ALREADY_ADDED = 'ALREADY_ADDED',
  FORMAT_ERROR = 'FORMAT_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
